// PatientData Model
import { Model } from '@vuex-orm/core'

export default class DocumentScanIPD extends Model {
  // This is the name used as module name of the Vuex Store.
  static entity = 'DocumentScanIPDs'

  // List of all fields (schema) of the post model. `this.attr` is used
  // for the generic field type. The argument is the default value.
  static fields() {
    return {
      id: this.attr(null),
      hn: this.attr(null),
      an: this.attr(null),
      documentGroups: this.attr(null),
      documentScans: this.attr(null),
      documentLocation: this.attr(null)

    }
  }
}

